module.exports = __webpack_public_path__ + "images/xl-guangdong.jpg?d32b8852135b802f7785c0f0fba6244a";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/xl-guangdong.jpg
// module id = 206
// module chunks = 1